<div class="content space-y-4">

    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <fa-icon [icon]="faTags" class="text-primary-500 text-xl"></fa-icon>
            <span>Price List</span>
        </div>
        <div class="flex gap-2">
            <a [routerLink]="['/price-list/mapping']">
                <button class="btn-sm btn-secondary w-fit self-end content-center">
                    Campaign Mapping
                </button>
            </a>
            @if (canAccess()) {
            <button class="btn-sm btn-primary w-fit self-end content-center"
                (click)="openValidateDialog()">ตรวสอบราคา</button>
            }
        </div>
    </div>

    <div class="card">
        <form [formGroup]="form" class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div class="w-full">
                <label class="text-sm">สินค้า</label>
                <input class="input" type="text" placeholder="กรอกชื่อ/รหัสสินค้า" formControlName="keyword">
            </div>
            <div class="">
                <label class="text-sm">การใช้งาน</label>
                <mat-form-field class="w-full">
                    <mat-select class="" placeholder="เลือกการใช้งาน" formControlName="visible">
                        <mat-option value="">ทั้งหมด</mat-option>
                        <mat-option value="true">เปิดใช้งาน</mat-option>
                        <mat-option value="false">ปิดใช้งาน</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="">
                <label class="text-sm">ราคาแคมเปญ</label>
                <mat-form-field class="w-full">
                    <mat-select class="" placeholder="เลือกราคาแคมเปญ" formControlName="is_price">
                        <mat-option value="">ทั้งหมด</mat-option>
                        <mat-option value="true">มีราคาแคมเปญ</mat-option>
                        <mat-option value="false">ยังไม่มีราคาแคมเปญ</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <button class="btn-sm btn-primary w-fit self-end" (click)="submitForm()">ค้นหา</button>
        </form>
    </div>


    @if(loading){
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    }
    @if (!loading && dataSource.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium">Data Not Found</div>
        </div>
    </div>
    }
    @else if (!loading && dataSource.length > 0){
    <div class="card">
        @if (hiddenColumnList.length > 0) {
        <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm text-gray-500">ซ่อน:</span>
            @for (c of hiddenColumnList; track c.id) {
            <button class="label label-light !text-xs flex items-center gap-1 border"
                [style.background-color]="c.color" type="button" (click)="toggleHideColumn(c.id)"
                matTooltip="กดเพื่อแสดงคอลัมน์">
                <fa-icon [icon]="faEyeSlash" class="text-gray-500"></fa-icon>
                <span>{{c.name}}</span>
            </button>
            }
            @if (hiddenColumnList.length > 1) {
            <button class="text-xs text-primary-500 hover:underline" type="button"
                (click)="showAllHiddenColumns()">แสดงทั้งหมด</button>
            }
        </div>
        }
        <div class="mt-2">
            <div class="div-table">
                <table>
                    <thead>
                        <tr>
                            <th rowspan="2" class="border-r sticky left-0 w-[320px] truncate bg-inherit"
                                style="background-color: #f7d7d7;">รายการ</th>
                            <th rowspan="2" class="border-r" style="background-color: #fffae9;">Date</th>
                            @for (item of displayedColumns; track $index) {
                            @if(checkDisplayColumn(item.id) && (item.rowspan === 2 || hasVisibleCampaigns(item.id))){
                            <th [attr.rowspan]="item.rowspan" [attr.colspan]="getColSpan(item.id)"
                                class="border-r relative group" [ngStyle]="{'background-color': item.color}">
                                <span>{{item.name}}</span>
                                <fa-icon *ngIf="item.note" [icon]="faQuestionCircle" class="text-gray-500 ml-1"
                                    [matTooltip]="item.note" matTooltipClass="text-sm"></fa-icon>
                                <button type="button"
                                    class="absolute top-0.5 right-1 text-gray-500 opacity-40 hover:opacity-100 transition-opacity"
                                    (click)="toggleHideColumn(item.id)" matTooltip="ซ่อนคอลัมน์">
                                    <fa-icon [icon]="faEye" class="text-xs"></fa-icon>
                                </button>
                            </th>
                            }
                            }
                            <th rowspan="2" class="border-r">Note</th>
                            <th rowspan="2">การใช้งาน</th>
                        </tr>
                        <tr>
                            @for (item of campaignData; track $index) {
                            <th *ngIf="checkDisplayColumn(item.campaign_group_id) && checkDisplayColumn(item.id)"
                                class="border-r text-xs relative group" [ngStyle]="{'background-color': item.color}">
                                <span>{{item.name}}</span>
                                <button type="button"
                                    class="absolute top-0.5 right-1 text-gray-500 opacity-40 hover:opacity-100 transition-opacity"
                                    (click)="toggleHideColumn(item.id)" matTooltip="ซ่อนคอลัมน์">
                                    <fa-icon [icon]="faEye" class="text-xs"></fa-icon>
                                </button>
                            </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (product of dataSource; track $index) {
                        <tr class="tbody-tr">
                            <td class="sticky left-0 w-[320px] bg-inherit border-r !border-b !border-t">
                                <div class="w-[320px] flex items-center">
                                    <button (click)="addPriceList(product)" class="mr-2"> <fa-icon [icon]="faPlusCircle"
                                            class="text-primary-500 text-lg"></fa-icon></button>
                                    <div class="w-full truncate flex items-center cursor-pointer"
                                        (click)="selectedRowOnChange(product)" [matTooltip]="product.name"
                                        matTooltipClass="text-sm">
                                        <img [src]="'https://storage.maxxgadget.com/img/product/' + product.sku + '/1.jpg'"
                                            alt="" class="flex-none w-8 h-8 mr-2"
                                            onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                        <div class="w-full flex flex-col truncate">
                                            <div class="w-full truncate whitespace-nowrap">{{product.name}}</div>
                                            <div class="flex gap-2 items-center">
                                                <span class="text-xs pr-2 text-blue-500">{{product.sku}}</span>
                                                <span *ngIf="!product.visible"
                                                    class="label label-danger">ปิดใช้งาน</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="border-r">
                                <div class="whitespace-nowrap">{{dateFormat(product.created.date)}}</div>
                            </td>
                            <td *ngIf="checkDisplayColumn('retail_price')" class="border-r text-right">
                                <button *ngIf="!isEditing[product.id + '' + 'retail']"
                                    class="text-right font-semibold !w-16" [disabled]="!canAccess()"
                                    [ngClass]="{'text-black': product.retail_price > 0, 'text-red-500': product.retail_price == 0 || !product.retail_price}"
                                    (click)="toggleEditPrice(product.id, 'retail')">
                                    {{product.retail_price | number}}
                                </button>

                                <input *ngIf="isEditing[product.id + '' + 'retail']" type="number" id="price-add"
                                    class="input !w-16 text-right" autocomplete="off" [(ngModel)]="price" [min]="0"
                                    [placeholder]="product.retail_price | number"
                                    (focusout)="toggleEditPrice(product.id, 'retail')"
                                    (keyup.enter)="updateRetail(product.id)" />
                            </td>
                            <td *ngIf="checkDisplayColumn('online_price')" class="border-r text-right">
                                <div class="">{{product.online_price | number}}</div>
                            </td>
                            <td *ngIf="checkDisplayColumn('cost')" class="border-r text-right">
                                <div class="">{{product.cost | number}}</div>
                            </td>
                            <td *ngIf="checkDisplayColumn('cost_platform')" class="border-r text-right">
                                <div class="">{{calculateCostPlatform(product.cost) | number}}</div>
                            </td>
                            @for (campaign of priceCampaign; track $index) {
                            <td *ngIf="checkDisplayColumn(campaign.campaign_group_id) && checkDisplayColumn(campaign.id)"
                                class="border-r text-right">
                                <button *ngIf="!isEditing[product.id + '' + campaign.id]"
                                    class="text-right font-semibold !w-16" [disabled]="!canAccess()"
                                    [ngClass]="{'text-black': getProductPrice(product.price_campaign, campaign.id) > 0, 'text-red-500': getProductPrice(product.price_campaign, campaign.id) == 0 || !getProductPrice(product.price_campaign, campaign.id)}"
                                    (click)="toggleEditPrice(product.id, campaign.id)">
                                    {{ getProductPrice(product.price_campaign, campaign.id) | number }}
                                </button>

                                <input *ngIf="isEditing[product.id + '' + campaign.id]" type="number" id="price-add"
                                    class="input !w-16 text-right" autocomplete="off" [(ngModel)]="price" [min]="0"
                                    [placeholder]="getProductPrice(product.price_campaign, campaign.id) | number"
                                    (focusout)="toggleEditPrice(product.id, campaign.id)"
                                    (keyup.enter)="updatePrice(product.id, campaign.id)" />
                            </td>
                            }
                            <td class="border-r w-fit">
                                <div class="w-max text-red-500 cursor-pointer"
                                    (click)="openNoteDialog(product.id,product.note)"
                                    [innerHTML]="setFormattingNote(product?.note)"></div>
                            </td>
                            <td class="w-fit">
                                <app-toggle [id]="'toggle-'+product.id" [callbackToggle]="callbackActiveToggle"
                                    [defaultValue]="product.visible"></app-toggle>
                            </td>
                        </tr>

                        <tr class="text-gray-600/60">
                            @if (selectedRow === product.id && selectedPriceList.length === 0){
                            <td class="sticky left-0 w-[320px] bg-white"> ไม่มีการแก้ไขราคา </td>
                            <td colspan="100"></td>
                            }
                            @else if (selectedRow === product.id && selectedPriceList.length > 0) {
                            <ng-container *ngTemplateOutlet="rowPriceListTemplate"> </ng-container>
                            }
                        </tr>

                        }
                    </tbody>
                </table>
            </div>
            <app-pagination [callBackPageChange]="callBackPageChange" [pageSize]="pageSize" [pageIndex]="pageIndex"
                [length]="countDataSource"></app-pagination>
        </div>
    </div>
    }

</div>




<ng-template #rowPriceListTemplate>
    <td class="sticky left-0 w-[320px] bg-white border-r">
        ...
    </td>
    <td class="border-r">
        @for (row of selectedPriceList; track $index) {
        <div class="whitespace-nowrap">{{dateFormat(row.created.date)}}</div>
        }
    </td>
    <td *ngIf="checkDisplayColumn('retail_price')" class="border-r text-right">
        @for (row of selectedPriceList; track $index){
        <div>{{row.retail_price | number}}</div>
        }
    </td>
    <td *ngIf="checkDisplayColumn('online_price')" class="border-r text-right">
        @for (row of selectedPriceList; track $index){
        <div>{{row.online_price | number}}</div>
        }
    </td>
    <td *ngIf="checkDisplayColumn('cost')" class="border-r text-right">
        @for (row of selectedPriceList; track $index){
        <div>{{row.cost | number}}</div>
        }
    </td>
    <td *ngIf="checkDisplayColumn('cost_platform')" class="border-r text-right">
        @for (row of selectedPriceList; track $index){
        <div>{{calculateCostPlatform(row.cost) | number}}</div>
        }
    </td>
    @for (campaign of priceCampaign; track $index) {
    <td *ngIf="checkDisplayColumn(campaign.campaign_group_id) && checkDisplayColumn(campaign.id)"
        class="border-r text-right">
        @for (row of selectedPriceList; track $index){
        <div>{{ getProductPrice(row.price_campaign,
            campaign.id) | number }}</div>
        }
    </td>
    }
    <td class="border-r text-left">
        @for (row of selectedPriceList; track $index){
        <div class="whitespace-nowrap text-red-500">{{row?.note || '-'}}</div>
        }
    </td>
    <td></td>
</ng-template>